export default "__VITE_ASSET__Da6sKXfP__"